var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notes_datatable"},[_c('datatable',{attrs:{"type":'notes',"recordType":'order_job',"rowData":_vm.notes,"loadingMessage":_vm.loadingMessage,"noRowsMessage":_vm.noRowsMessage,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }